// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"CurrentState_pageWrap__3GH9e","wrapper":"CurrentState_wrapper__3DTUy","subtitle":"CurrentState_subtitle__1t5AZ","btnDefault":"CurrentState_btnDefault__3aFWW"};